import BaseService from "./base.service";

export default class ContactService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    sendContact = (values) => {
        return this.post('/contact', values)
    }
}